.container {
  font-size: var(--tuna-typography-fontSize-xs);
  height: 100%;
  display: flex;
  flex-direction: column;
  border-left-style: solid;
  border-left-width: 4px;
  justify-content: space-evenly;
  user-select: none;
}

.container--selected {
  background-color: var(--tuna-palette-action-hover);
}

.row {
  justify-content: space-between;
  padding: 0 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.nameField {
  font-size: var(--tuna-typography-fontSize-xs);
}

.nameInput {
  font-size: var(--tuna-typography-fontSize-xs);
  padding: 0;
  text-align: right;
}

.meterRow {
  height: 8px;
}
